import React from 'react';
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { shouldShowMore } from "../../../actions";
import { Row, Divider } from 'antd';
import {
    SubHeadTitle,
    ValueStyle
  } from "../Details/styles";
import upArrow from "../../../../../../assets/icons/short-arrow-t-green.svg";
import percentIcon from "../../../../../../assets/icons/percentage-discount.svg"
import { ImageWrap } from "../../../Step2LegacyOptions/Components/AccordionContent/styles";
import { PillButtonSelectSpace } from "../LegacyAccordions/styles";
import { DividerWrap } from "../Details/styles";
import { AccContentWrap, ButtonWrap, MarginBottom, PercentageWrap, PercentageImageWrap, DisplayStyle, PercentWrap, InnerContentWrapper } from './styles';
import AccordionOpenState from "../AccordionOpenState";

export const AccordionContent = (props) => {
    return (
        <InnerContentWrapper id={props.contentKey}>
            {
                props.contentKey == 3 || props.contentKey == 5 ? 
                <div>
                    <Row>
                        <AccContentWrap>
                        <DividerWrap><Divider /></DividerWrap>
                        <PercentageWrap>
                        <PercentageImageWrap src={percentIcon} alt="Percentage" />
                        <DisplayStyle>
                            <SubHeadTitle>Percentage endowed</SubHeadTitle>
                            </DisplayStyle>
                            </PercentageWrap>
                            <MarginBottom marginBottom="30px">

                            <PercentWrap>
                            <ValueStyle lineHeight="2">{props.percentage}%</ValueStyle>
                            </PercentWrap>
                            </MarginBottom>
                            <ButtonWrap>
                            <PillButtonSelectSpace data-test="show-less-button" onClick={(e) => props.handleShowLess(e)} id={"btnShowless"+props.contentKey}>
              Show Less <ImageWrap src={upArrow} alt="Up Arrow" />
            </PillButtonSelectSpace>
            </ButtonWrap>
            </AccContentWrap>
                    </Row>
                    
                </div> : props.contentKey === 1 || props.contentKey === 2 ? <div>
                    <Row>
                    <AccContentWrap>
                     <DividerWrap><Divider /></DividerWrap>
                     <AccordionOpenState contentKey={props.contentKey} />
                     <ButtonWrap>
                            <PillButtonSelectSpace data-test="show-less-button" onClick={(e) => props.handleShowLess(e)} id={"btnShowless"+props.contentKey}>
              Show Less <ImageWrap src={upArrow} alt="Up Arrow"  />
            </PillButtonSelectSpace>
            </ButtonWrap>
                    </AccContentWrap>
                    </Row>
                </div> : props.contentKey === 4 ? 
                <div>
                    <Row>
                    <AccContentWrap>
                     <DividerWrap><Divider /></DividerWrap>
                     <AccordionOpenState contentKey={props.contentKey} />
                     <ButtonWrap>
                            <PillButtonSelectSpace data-test="show-less-button" onClick={(e) => props.handleShowLess(e)} id={"btnShowless"+props.contentKey}>
              Show Less <ImageWrap src={upArrow} alt="Up Arrow"  />
            </PillButtonSelectSpace>
            </ButtonWrap>
                    </AccContentWrap>
                    </Row>
                </div> : null
            }
        </InnerContentWrapper>
    )
}

const mapStateToProps = (state, ownProps) => ({
    percentage: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions", "legacyOptions",`${ownProps.contentKey - 1}`, "percentage"])
});

const mapDispatchToProps = dispatch => ({
  shouldShowMore: val => dispatch(shouldShowMore(val)) 
})

AccordionContent.propTypes = {
    contentKey: PropTypes.number,
    handleShowLess: PropTypes.func,
    percentage: PropTypes.string,
    shouldShowMore: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(AccordionContent);